// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ComponentProps} from 'react';
import cn from 'classnames';
import {Checkbox as Basic_checkbox} from '../../../hola/pub/lib/checkbox';
import Icon_check from '../img/icons/16/check.svg';
import styles from './checkbox.module.less';

export type t_oculus_checkbox_color = 'default';
export type t_oculus_checkbox_size = 'm' | 's';

export type t_oculus_checkbox_props = ComponentProps<typeof Basic_checkbox> & {
    color?: t_oculus_checkbox_color;
    size?: t_oculus_checkbox_size;
};

const icon_sizes = {
    s: 12,
    m: 14,
};

export const Checkbox = (props: t_oculus_checkbox_props)=>{
    const {cls, color = 'default', size = 'm', ...rest} = props;
    const checkbox_cls = cn(cls, styles.oculus_checkbox, styles[color],
        styles[`size_${size}`]);
    const icon_size = icon_sizes[size];
    return <Basic_checkbox<t_oculus_checkbox_color, t_oculus_checkbox_size>
      cls={checkbox_cls}
      icon={<Icon_check width={icon_size} height={icon_size}/>} {...rest}
    />;
};
